"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ContentWrapper", {
    enumerable: true,
    get: function() {
        return ContentWrapper;
    }
});
const _components = require("@react-email/components");
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _constants = require("~/constants");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const ContentWrapper = ({ children, disableContainerPadding })=>{
    return /*#__PURE__*/ _react.createElement(_components.Container, {
        className: "px-3 mt-16 !my-0 max-w-[480px]"
    }, /*#__PURE__*/ _react.createElement(_components.Section, {
        className: "py-6 m-auto bg-gray-50 border border-gray-200 border-solid rounded-t-xl"
    }, /*#__PURE__*/ _react.createElement(_components.Img, {
        alt: "NocoDB",
        src: `${_constants.NC_EMAIL_ASSETS_BASE_URL}/nocodb-logo.png`,
        width: 40,
        style: {
            display: 'block',
            margin: 'auto auto'
        },
        height: 40
    })), /*#__PURE__*/ _react.createElement(_components.Section, {
        className: `border border-gray-200 border-solid border-t-0 rounded-b-xl bg-white ${disableContainerPadding ? 'p-0' : 'p-6'}`
    }, children), /*#__PURE__*/ _react.createElement(_components.Hr, {
        className: "!my-16"
    }));
};
